module.exports = __webpack_public_path__ + "img/cjyj.3c3c0e3a.png";